var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C4.2 20 1 12 1 12C1 12 4.2 4 12 4C19.8 4 23 12 23 12C23 12 19.8 20 12 20ZM2.49345 12.7597C2.32126 12.4536 2.18949 12.1937 2.09652 12C2.18949 11.8063 2.32126 11.5464 2.49345 11.2403C2.88981 10.5356 3.49393 9.59786 4.32293 8.66378C5.98161 6.79485 8.48053 5 12 5C15.5195 5 18.0184 6.79485 19.6771 8.66378C20.5061 9.59787 21.1102 10.5356 21.5065 11.2403C21.6787 11.5464 21.8105 11.8063 21.9035 12C21.8105 12.1937 21.6787 12.4536 21.5065 12.7597C21.1102 13.4644 20.5061 14.4021 19.6771 15.3362C18.0184 17.2052 15.5195 19 12 19C8.48053 19 5.98161 17.2052 4.32293 15.3362C3.49393 14.4021 2.88981 13.4644 2.49345 12.7597ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23857 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5cc1f6f0.svg";
export { ForwardRef as ReactComponent };